export class ThirdPartyRateProvider {
  id?: number;
  name?: string;
  naturalId?: string;

  constructor(opts?: Partial<ThirdPartyRateProvider>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.naturalId != null) {
      this.naturalId = opts.naturalId;
    }
  }
}
